import { appConfig } from './utils/config';

const oktaConfig = appConfig.okta;

export default oktaConfig;
